import {useTranslation} from "react-i18next";
import {useState} from "react";
import {Consts} from "../../pages/consts";
import IntakePlan from "./IntakePlan";
import TimingTypeRadioGroup from "./TimingTypeRadioGroup";
import IntakeTypeRadioGroup from "../../drugs/IntakeTypeRadioGroup";
import IntakesFrequencyAndDosageUnit from "./IntakesFrequencyAndDosageUnit";

const Intakes = ({onSaveDrug, selectedDrug, setSelectedDrug, initIntakes, showDialog}) => {
  const {t} = useTranslation();
  const [intakesCompleted, setIntakesCompleted] = useState(false);

  const cleanIntakesAndSaveDrug = () => {
    const cleanedIntakes = selectedDrug?.intakes?.filter(intake =>
      intake?.intakeTime !== "" && !isNaN(intake?.dosage ) && intake?.dosage > 0);

    onSaveDrug({...selectedDrug, intakes: cleanedIntakes});
  };

  const handleSetIntakeType = (intakeTypeObj) => {
    setSelectedDrug({...selectedDrug, ...intakeTypeObj});
  }

  const enableSubmit = selectedDrug?.intakeType === Consts.ON_DEMAND
    || (
      selectedDrug?.timingType !== ""
      && initIntakes
      && selectedDrug?.dosageUnit && selectedDrug?.dosageUnit?.dosageUnit !== ""
      && intakesCompleted
    );

  return (
    <div
      className="w3-modal"
      style={ {display: showDialog ? Consts.BLOCK : Consts.NONE} }
    >
      <div
        className={ `w3-modal-content w3-card-4 w3-animate-zoom form-panel ${
          initIntakes ? "dialog-medium" : "dialog-narrow"
        }` }
      >
        { initIntakes ? (
          <>
            <header className="w3-container w3-padding-small w3-center">
              <p>
                { t("please_specify_an_intake_plan_for") }{ " " }
                { selectedDrug?.productName }
              </p>
            </header>
            <div className="w3-container">
              <IntakeTypeRadioGroup onSetIntakeType={ handleSetIntakeType }/>
              { selectedDrug?.intakeType === Consts.REGULARLY && (
                <>
                  <IntakesFrequencyAndDosageUnit
                    selectedDrug={ selectedDrug }
                    setSelectedDrug={ setSelectedDrug }
                  />
                  <TimingTypeRadioGroup
                    selectedDrug={ selectedDrug }
                    setSelectedDrug={ setSelectedDrug }
                    setIntakesCompleted={ setIntakesCompleted }
                  />
                </>
              ) }
            </div>
          </>
        ) : (
          <IntakePlan selectedDrug={ selectedDrug }/>
        ) }
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            { initIntakes && (
              <button
                className="w3-btn w3-round-xlarge w3-theme-d5"
                onClick={ cleanIntakesAndSaveDrug }
                disabled={ !enableSubmit }
              >
                { t("submit") }
              </button>
            ) }
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={ () => showDialog(false) }
            >
              { t("cancel") }
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Intakes;
